// import { useState } from 'react'
// import './create-form.css'
// import { RhyBusButton } from '@rhybus/button'

// export default function StudentTable(props: any) {
//   const [_data, setData] = useState(props.initialData)
//   const handleDelete = (id:any) => {
//     setData((prev: any[]) => prev.filter((r) => r.id !== id))
//   }
//   return (
//     <div>
//       <div >

//           <table className='formtable'>
//             <thead>
//               <tr >
//                 {props?.headerColumns.map((col:any) => (
//                   <th key={col.key}>
//                     {col.label}
//                   </th>
//                 ))}
//                 {props?.isEdit && (
//                   <th className='formactions'></th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {props?.initialData.map((row:any) => {
//                 return (
//                   <tr
//                     key={row.id}
//                   >
//                     {props?.headerColumns.map((col:any) => (
//                       <td key={col.key} >
//                         {col.key === 'financialStatus' ? (
//                           <span
//                           >
//                             {row[col.key]}
//                           </span>
//                         ) : col.key === 'tMasl' ? (
//                           <span>{row[col.key]}</span>
//                         ) : (
//                           <span>{row[col.key as keyof typeof row]}</span>
//                         )}
//                       </td>
//                     ))}
//                     {props?.isEdit &&
//                     <td className='formactions'>
//                       <RhyBusButton
//                         className="edit-btn"
//                         variant='text'
//                         ariaLabel="Edit"
//                         leftIcon='icon-rb-pencil'
//                       />
//                       <RhyBusButton
//                         className="del-btn"
//                         variant='text'
//                         onClick={() => handleDelete(row.id)}
//                         ariaLabel="Delete"
//                         leftIcon='icon-rb-trashbin'
//                       />
//                     </td>
//                     }
//                   </tr>
//                 )
//               })}
//               {props?.initialData.length === 0 && (
//                 <tr>
//                   <td colSpan={props?.headerColumns.length + 1} >
//                     No records found.
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//   )
// }


import { useState, useEffect } from 'react'
import './create-form.css'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusCustomSelect, RhyBusInputText, RhyBusDatePicker } from '@rhybus/form-controls'
import { RhyBusNoresult } from '@rhybus/noresult'

export default function StudentTable(props: any & { fixFirstColumn?: boolean; fixLastColumn?: boolean }) {
  const [_data, setData] = useState(props.initialData)

  useEffect(() => {
    const sorted = [...(props.initialData ?? [])].sort(
      (a: any, b: any) => (parseInt(a.training || '0', 10)) - (parseInt(b.training || '0', 10))
    )
    setData(sorted)
  }, [props.initialData])

  const [editRowId, setEditRowId] = useState<number | null>(null)
  const [editedRow, setEditedRow] = useState<any>({})
  const [rowErrors, setRowErrors] = useState<Record<string, string>>({})

  useEffect(() => {
    if (props.resetEditKey === undefined) return
    setEditRowId(null)
    setEditedRow({})
    setRowErrors({})
  }, [props.resetEditKey])
  const fieldKeyAliases: Record<string, string> = {
    tMasl: 'tmasl',
  }

  const getEditField = (key: string) =>
    props?.editFields?.find((field: any) => field.key === (fieldKeyAliases[key] ?? key))

  const getSelectValue = (options: any[] = [], value: any) => {
    if (!value || typeof value === 'object') return value || null
    return options.find((option: any) => String(option.value) === String(value) || String(option.label) === String(value))
      ?? { label: String(value), value: String(value) }
  }

  const handleDelete = (id: any) => {
    setData((prev: any[]) => {
      const updated = prev.filter((r) => r.id !== id)
      props?.onDataChange?.(updated)
      return updated
    })
  }

  const handleEdit = (row: any) => {
    setEditRowId(row.id)
    setEditedRow({ ...row })
    setRowErrors({})
  }

  const handleChange = (key: string, value: string) => {
    setEditedRow((prev: any) => ({ ...prev, [key]: value }))
    if (rowErrors[key]) setRowErrors(prev => { const n = { ...prev }; delete n[key]; return n })
  }

  const handleSave = () => {
    const errors: Record<string, string> = {}
    props?.headerColumns?.forEach((col: any) => {
      const field = getEditField(col.key)
      if (!field?.isMandatory || field?.type === 'button') return
      const val = editedRow[col.key]
      const isEmpty = field.type === 'select'
        ? !val || val === ''
        : !(val?.toString().trim())
      if (isEmpty) errors[col.key] = `${field.label} is required`
    })
    const extraErrors = props?.onValidateRow?.(editedRow) ?? {}
    Object.assign(errors, extraErrors)
    if (Object.keys(errors).length > 0) {
      setRowErrors(errors)
      return
    }
    setRowErrors({})
    setData((prev: any[]) => {
      const updated = prev.map((row) =>
        row.id === editRowId ? editedRow : row
      )
      props?.onDataChange?.(updated)
      return updated
    })
    setEditRowId(null)
    setEditedRow({})
  }

  return (
    <div className='formtable-wrapper'>
      <div className='overflow-auto'>
        <table className="formtable">
          <thead>
            <tr>
              {props?.headerColumns.map((col: any, idx: number) => {
                const isFirst = idx === 0
                const isLast = !props?.isEdit && idx === props.headerColumns.length - 1
                const stickyClass = (isFirst && props?.fixFirstColumn ? ' col-sticky-first' : '') +
                  (isLast && props?.fixLastColumn ? ' col-sticky-last' : '')
                return <th key={col.key} className={`${props.thClassname} ${stickyClass.trim() || ''}`}>{col.label}</th>
              })}

              {props?.isEdit && (
                <th className={`formactions${props?.fixLastColumn ? ' col-sticky-last' : ''}`}></th>
              )}
            </tr>
          </thead>

          <tbody>
            {_data.map((row: any) => {
              const isEditing = editRowId === row.id

              return (
                <tr key={row.id}>
                  {props?.headerColumns.map((col: any, idx: number) => {
                    const isFirstCol = idx === 0
                    const isLastCol = !props?.isEdit && idx === props.headerColumns.length - 1
                    const stickyClass = (isFirstCol && props?.fixFirstColumn ? 'col-sticky-first' : '') +
                      (isLastCol && props?.fixLastColumn ? 'col-sticky-last' : '')
                    const tdClass = [isEditing ? 'form-input padding-0' : '', stickyClass].filter(Boolean).join(' ')
                    return (
                      <td key={col.key} className={`${props?.tdClassname} ${tdClass || ''}`}>
                        {isEditing && getEditField(col.key)?.type === 'select' ? (
                          <RhyBusCustomSelect
                            id={`line-${row.id}-${col.key}`}
                            options={getEditField(col.key)?.options ?? []}
                            value={getSelectValue(getEditField(col.key)?.options, editedRow[col.key])}
                            onChange={(value: any) =>
                              handleChange(col.key, value?.value ?? value ?? '')
                            }
                            error={!!rowErrors[col.key]}
                            errorMessage={rowErrors[col.key] || ''}
                            placeholder={getEditField(col.key)?.placeholder ?? 'Select'}
                          />
                        ) : isEditing && getEditField(col.key)?.type === 'date' ? (
                          <div className="table-datepicker-cell">
                            <RhyBusDatePicker
                              id={`line-${row.id}-${col.key}`}
                              value={(() => {
                                const v = editedRow[col.key]
                                if (!v) return null
                                if (v instanceof Date) return v
                                const d = new Date(v)
                                return isNaN(d.getTime()) ? null : d
                              })()}
                              onChange={(v: any) => {
                                const d = v instanceof Date ? v : typeof v?.toDate === 'function' ? v.toDate() : null
                                if (d && !isNaN(d.getTime())) {
                                  const year = d.getFullYear()
                                  const month = String(d.getMonth() + 1).padStart(2, '0')
                                  const day = String(d.getDate()).padStart(2, '0')
                                  handleChange(col.key, `${year}-${month}-${day}T12:00:00.000Z`)
                                } else {
                                  handleChange(col.key, v ?? '')
                                }
                              }}
                              placeholder={getEditField(col.key)?.placeholder ?? 'MM/DD/YYYY'}
                              formlayout="vertical"
                              onOpenChange={() => {}}
                            />
                            {rowErrors[col.key] && <div style={{ color: '#C83434', fontSize: '12px', marginTop: '2px' }}>{rowErrors[col.key]}</div>}
                          </div>
                        ) : isEditing ? (
                          <RhyBusInputText
                            type="text"
                            value={editedRow[col.key] || ''}
                            onChange={(e) =>
                              handleChange(col.key, e.target.value)
                            }
                            error={!!rowErrors[col.key]}
                            errorMessage={rowErrors[col.key] || ''}
                          />
                        ) : (
                          <span>{getEditField(col.key)?.type === 'date' && row[col.key]
                              ? (() => { const d = new Date(row[col.key]); return isNaN(d.getTime()) ? row[col.key] : d.toLocaleDateString() })()
                              : row[col.key]}</span>
                        )}
                      </td>
                    )
                  })}

                  {props?.isEdit && (
                    <td className={`formactions ${props?.tdClassname}  ${props?.fixLastColumn ? ' col-sticky-last' : ''}`}>
                      <div className="d-flex align-items-center">
                        {isEditing ? (
                          <RhyBusButton
                            className="save-btn"
                            variant="text"
                            size='xs'
                            ariaLabel="Save"
                            leftIcon="icon-rb-save"
                            onClick={handleSave}
                          />
                        ) : (
                          <RhyBusButton
                            className="edit-btn"
                            variant="text"
                            size='xs'
                            ariaLabel="Edit"
                            leftIcon="icon-rb-pencil font-12 color-primary"
                            onClick={() => handleEdit(row)}
                          />
                        )}
                        <RhyBusButton
                          className="del-btn"
                          variant="text"
                            size='xs'
                          onClick={() => handleDelete(row.id)}
                          ariaLabel="Delete"
                          leftIcon="icon-rb-trashbin font-12"
                        />
                      </div>
                    </td>
                  )}
                </tr>
              )
            })}

            {_data.length === 0 && (
              <tr>
                <td className={props?.noresultClassname} colSpan={props?.headerColumns.length + 1}>
                  <RhyBusNoresult title={props?.noResultText || 'No records found.'} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
